export default __webpack_public_path__ + "static/media/add_button.4301379d.svg";